import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg组件
  
// register globally
Vue.component('svgIcon', SvgIcon);
const req = require.context('./svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req);


// 减少引用 插入 loading 只要svg 以下代码可删除
Vue.directive('loads',{
    bind(el,value){
      if(value.value){
        const canPush = el.getElementsByClassName("customLoading");
        if(canPush.length!=0){
          return
        }
        el.style.position = "relative";
        const para = document.createElement("div");
        const i_son = document.createElement("i");//也可用image loading制定义;菜逼的我 尝试svg loading加载失败 
        para.setAttribute("class","customLoading");
        i_son.setAttribute("icon-class","loading");
        i_son.setAttribute("class","retate iconfont icon-Loading");
        para.appendChild(i_son);
        el.appendChild(para);
      }else{
        for (var i = 0; i < el.childNodes.length; i++) {
          if(el.childNodes[i].className == 'customLoading'){
            const childNodes = el.getElementsByClassName("customLoading")[0];
            el.removeChild(childNodes)
            break
          }
        }
      }
    },
    update(el,value) {
      if(value.value){
        const canPush = el.getElementsByClassName("customLoading");
        if(canPush.length!=0){
          return
        }
        el.style.position = "relative";
        const para = document.createElement("div");
        const i_son = document.createElement("i");
        para.setAttribute("class","customLoading");
        i_son.setAttribute("class","retate iconfont icon-Loading");
        para.appendChild(i_son);
        el.appendChild(para);
      }else{
        for (var i = 0; i < el.childNodes.length; i++) {
          if(el.childNodes[i].className == 'customLoading'){
            const childNodes = el.getElementsByClassName("customLoading")[0];
            el.removeChild(childNodes);
            break
          }
        }
      }
    }
  })


// WEBPACK FOOTER //
// ./src/assets/svgs/index.js